import ReportController from './report.controller';

export default class DomesticReportController extends ReportController
{
	get endpoint() {
		return 'domestic';
	}

	get title() {
		return 'Domestic Pax Report';
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/domestic.report.controller.js
 **/